import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const slideDown = keyframes`
  from { transform: translateY(-30px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

export const ModalBackdrop = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(5px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    animation: ${fadeIn} 0.3s ease-out;
`;

export const ModalContent = styled.div`
    background: rgba(30, 30, 30, 0.95);
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
    width: 90%;
    max-width: 800px;
    max-height: 90vh;
    overflow-y: auto;
    animation: ${slideDown} 0.4s ease-out;
`;

export const ModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 30px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    
    h2 {
        margin: 0;
        color: #E6AA3A;
        font-size: 22px;
        display: flex;
        align-items: center;
        gap: 10px;
    }
`;

export const CloseButton = styled.button`
    background: transparent;
    border: none;
    color: rgba(255, 255, 255, 0.7);
    font-size: 30px;
    cursor: pointer;
    transition: color 0.3s;
    &:hover { color: #E6AA3A; }
`;

export const Form = styled.form`
    padding: 30px;
    box-sizing: border-box;

    h4 {
        color: #fff;
        margin-top: 0;
        margin-bottom: 20px;
        border-left: 3px solid #E6AA3A;
        padding-left: 10px;
    }
`;

export const FormGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
    margin-bottom: 20px;
    
    .full-width {
        grid-column: 1 / -1;
    }
`;

export const InputGroup = styled.div`
    display: flex;
    flex-direction: column;
    
    label {
        color: rgba(255, 255, 255, 0.8);
        margin-bottom: 8px;
        font-size: 14px;
    }

    input {
        height: 45px;
        border: 1px solid rgba(255, 255, 255, 0.2);
        background: rgba(0,0,0,0.3);
        padding: 0 15px;
        color: #fff;
        border-radius: 6px;
        font-size: 16px;
        transition: border-color 0.3s;

        &:focus {
            outline: none;
            border-color: #E6AA3A;
        }
    }
`;

export const OptionalButton = styled.button`
    width: 100%;
    padding: 12px;
    background: transparent;
    border: 2px dashed rgba(255, 255, 255, 0.2);
    color: rgba(255, 255, 255, 0.7);
    border-radius: 6px;
    cursor: pointer;
    margin: 10px 0 20px 0;
    transition: all 0.3s;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    &:hover {
        background: rgba(230, 170, 58, 0.1);
        border-color: #E6AA3A;
        color: #E6AA3A;
    }
`;

export const Footer = styled.div`
    margin-top: 30px;
    text-align: right;
`;

export const ErrorMessage = styled.p`
    color: #ff4d4d;
    text-align: center;
    margin-bottom: 15px;
`;

export const SuccessMessage = styled.p`
    color: #4dff88;
    text-align: center;
    margin-bottom: 15px;
`;

export const SubmitButton = styled.button`
    background: #E6AA3A;
    color: #111;
    border: none;
    border-radius: 6px;
    padding: 12px 30px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover:not(:disabled) {
        background: #FFC300;
        transform: translateY(-2px);
        box-shadow: 0 4px 15px rgba(230, 170, 58, 0.4);
    }
    
    &:disabled {
        background: #555;
        color: #999;
        cursor: not-allowed;
    }
`;